import React, { ReactElement } from 'react';
import { withTranslation } from 'react-i18next';
import { TranslateTextLegacyPageProps, TranslateTextProps } from './types';

const TranslateText = (props: TranslateTextProps): ReactElement => {
  const { translationKey, t } = props;
  return <>{t(translationKey)}</>;
};

export const TranslateTextLegacyPage = ({
  translationNameSpace,
  translationKey,
}: TranslateTextLegacyPageProps): ReactElement => {
  const WithTranslationComponent = withTranslation([translationNameSpace])(
    TranslateText
  );
  return <WithTranslationComponent translationKey={translationKey} />;
};
